import React from 'react'
import type { CallToActionStripBlock as CTABlockProps } from '@/payload-types'
import { StripCTA } from '@/components/StripCTA'

export const CallToActionStripBlock: React.FC<CTABlockProps> = ({ links, richText }) => {
  return (
    <StripCTA
      links={links || undefined}
      richText={richText}
    />
  )
}

export const StripCTABlock = CallToActionStripBlock
